import { Box, Button, Link, Paper, TextField, Typography } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { MyListApi } from "../utils/restApi";
import { useDispatch, useSelector } from "react-redux";
import { addNotification } from "../slices/notificationSlice";
import { useForm } from "react-hook-form";

export const SignUp = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.login.user);

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors, isSubmitting, isValid },
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            username: '',
            email: '',
            password: '',
            repassword: '',
            referralCode: '',
        },
    });

    const password = watch('password');

    const onSubmit = async data => {
        MyListApi.signUp(data.username, data.email, data.password, data.referralCode)
            .then(() => {
                window.localStorage.setItem('validation-user', data.email);
                navigate(`/validation?username=${data.email}`);
            })
            .catch(error => {
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }

    return (
        <Paper sx={{
            width: '400px',
            m: 'auto',
        }}>
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <Box sx={{
                    padding: "16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                }}>
                    <TextField
                        label="Username (Email)"
                        id="email"
                        variant="filled"
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        fullWidth
                        {...register('email', {
                            required: 'Username (email) is required.',
                            pattern: { value: /^\S+@\S+\.\S+$/, message: "Enter a valid email" },
                        })}
                    />
                    <TextField
                        label="Display Name"
                        id="name"
                        variant="filled"
                        fullWidth
                        error={!!errors.username}
                        helperText={errors.username?.message}
                        {...register('username', {
                            required: 'Display name is required',
                            pattern: { value: /^[a-zA-Z0-9_-]+$/, message: 'Display name must only contain letters, numbers, dashes or underscores.'},
                        })}
                    />
                    <TextField
                        label="Password"
                        id="password"
                        variant="filled"
                        type="password"
                        fullWidth
                        error={!!errors.password}
                        helperText={errors.password?.message}
                        {...register('password', {
                            required: 'Password is required',
                            minLength: { value: 8, message: 'Password must be at least 8 characters' },
                            pattern: {
                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).+$/,
                            message:
                                "Must include upper & lower case, a number, and a special character",
                            },
                        })}
                    />
                    <TextField
                        label="Re-enter Password"
                        id="repassword"
                        variant="filled"
                        type="password"
                        fullWidth
                        error={!!errors.repassword}
                        helperText={errors.repassword?.message}
                        {...register('repassword', {
                            required: 'Please re-enter your password',
                            validate: v => v === password || 'Make sure password matches',
                        })}
                    />
                    <Typography>We're still building behind the scenes! For now, only folks with a referral code can sign up — but feel free to share your code if you've got one. Hang tight, we'll be opening the gates to everyone soon!</Typography>
                    <TextField
                        label="Referral Code"
                        id="referral_code"
                        variant="filled"
                        fullWidth
                        error={!!errors.referralCode}
                        helperText={errors.referralCode?.message}
                        {...register('referralCode', {
                            required: 'Please enter the referral code.',
                        })}
                    />
                </Box>
                <Box sx={{
                    padding: "16px",
                    display: "flex",
                    gap: "16px",
                    justifyContent: "flex-end",
                    flexWrap: "wrap",
                }}>
                    <Typography variant="caption" color="text.secondary" sx={{ mr: 'auto', alignSelf: 'center' }}>
                        See our <Link component={RouterLink} to="/privacy">Privacy Policy</Link> for how we handle your information.
                    </Typography>
                    <Button variant="contained" type="submit" disabled={!isValid || isSubmitting}>Submit</Button>
                </Box>
            </form>
        </Paper>
    );
}